
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/atencio/accessibilitat/contacte",
      function () {
        return require("private-next-pages/corporatiu/atencio/accessibilitat/contacte/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/atencio/accessibilitat/contacte"])
      });
    }
  